import { Action } from 'redux'
import { FormNameType } from 'interfaces/form'
import { FORM_SUBMITTED_SUCCESSFULLY, FormSubmittedSuccessfully } from 'actions/formActions'


/**===========================================================================
 * !                              DEPRECATED
 *==========================================================================**/

/**
 * @deprecated use src/actionTools/createAction.ts
 */
export function createAction<TType> (type: TType): Action {
  return { type }
}

/**
 * @deprecated use src/actionTools/createAction.ts
 */
export function createPayloadAction<TType, TPayload> (type: TType, payload: TPayload) {
  return { type, payload }
}

type IsFormSubmittedActionFunction = (...formTypes: FormNameType[]) => ((a: Action) => boolean)

/**
 * @deprecated use src/actionTools
 */
export const isFormSubmittedAction: IsFormSubmittedActionFunction = (...formTypes: FormNameType[]) =>
  (action: Action): boolean => {
    const formTypeSet = new Set(formTypes)

    return action.type === FORM_SUBMITTED_SUCCESSFULLY &&
      (
        formTypes.length === 0 || // pass any form if no `formTypes` passed
        formTypeSet.has((action as FormSubmittedSuccessfully).payload.formName)
      )
  }

export type RequestActions<TActionType extends Action['type'], TRequestParams, TResponse = {}> = {
  Request: {
    meta: 'request'
    type: TActionType
    payload: {
      params: TRequestParams
    }
  }
  Fail: {
    error: true
    meta: 'fail'
    type: TActionType
    payload: {
      params: TRequestParams
      errorCode: number
      errorExtra?: string[]
      errorsMap?: Record<string, string[]>
    }
  }
  Success: {
    meta: 'success'
    type: TActionType
    payload: {
      params: TRequestParams
      response: TResponse
    }
  }
}

export type RequestAction<TActionType extends Action['type'] = any, TRequestParams = any, TResponse = {}> =
  | RequestActions<TActionType, TRequestParams, TResponse>['Request']
  | RequestActions<TActionType, TRequestParams, TResponse>['Fail']
  | RequestActions<TActionType, TRequestParams, TResponse>['Success']

/**
 * @deprecated use src/actionTools/createRequestAction
 */
export function createRequestActionCreators<TActionType extends Action['type'], TRequestParams, TResponse = {}> (actionType: TActionType) {
  type T = RequestActions<TActionType, TRequestParams, TResponse>

  return {
    request: (params: TRequestParams): T['Request'] => ({
      meta: 'request',
      type: actionType,
      payload: { params },
    }),
    fail: (params: TRequestParams, errorCode = 0, errorExtra?: string[]): T['Fail'] => ({
      error: true,
      meta: 'fail',
      type: actionType,
      payload: { params, errorCode, errorExtra },
    }),
    error: (params: TRequestParams, errorCode = 0, errorsMap?: NonNullable<T['Fail']['payload']['errorsMap']>): T['Fail'] => ({
      error: true,
      meta: 'fail',
      type: actionType,
      payload: { params, errorCode, errorsMap },
    }),
    success: (params: TRequestParams, response: TResponse): T['Success'] => ({
      meta: 'success',
      type: actionType,
      payload: { params, response },
    }),
  }
}


/**
 * @deprecated use src/actionTools
 */
export function isRequestAction<TActionType extends Action['type'], TRequestParams, TResponse = {}>
(action: RequestAction<TActionType, TRequestParams, TResponse>): action is RequestActions<TActionType, TRequestParams, TResponse>['Request'] {
  return action.meta === 'request'
}

/**
 * @deprecated use src/actionTools
 */
export function isFailAction<TActionType extends Action['type'], TRequestParams, TResponse = {}>
(action: RequestAction<TActionType, TRequestParams, TResponse>): action is RequestActions<TActionType, TRequestParams, TResponse>['Fail'] {
  return action.meta === 'fail'
}

/**
 * @deprecated use src/actionTools
 */
export function isSuccessAction<TActionType extends Action['type'], TRequestParams, TResponse = {}>
(action: RequestAction<TActionType, TRequestParams, TResponse>): action is RequestActions<TActionType, TRequestParams, TResponse>['Success'] {
  return action.meta === 'success'
}

export type SpecificAction<T extends Action['type']> = Extract<Action, { type: T }>
